import { merge } from 'lodash';
import { DefaultPrivacyLevel, Site } from '@datadog/browser-rum';

export const envDefaults = {
  oidc: {
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
    tokenManager: {
      expireEarlySeconds: 60,
    },
  },
  // https://us5.datadoghq.com/rum/application/d0e8dc8d-918c-4a38-8219-c4478fb11c7c/manage
  datadog: {
    applicationId: 'd0e8dc8d-918c-4a38-8219-c4478fb11c7c',
    clientToken: 'pube0dada3a45e3b0139f859ab559214adb',
    site: 'us5.datadoghq.com' as Site,
    service: 'best---lari-application',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    defaultPrivacyLevel: DefaultPrivacyLevel.MASK,
  },
  features: {
    autosave: true,
  },
};

export const npdEnvDefaults = merge(envDefaults, {
  oidc: {
    clientId: '0oa15495upzY6mmOB1t8',
    issuer: 'https://mlbtest.okta.com/oauth2/ausa3295vsxer28Br1t7',
  },
});
